import * as React from "react";
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarRail,
} from "@/components/ui/sidebar";
import logoTextIcon from "@/assets/logoText.png";
import { ERoutes } from "./dashboardLayout.interface";
import { NavUser } from "./NavUser";
import useLocalUser from "@/hooks/useLocalUser";

const data = {
  navMain: [
    {
      title: "Dashboards",
      url: ERoutes.Activity,
      items: [
        {
          title: "Activity",
          url: ERoutes.Activity,
        },
        {
          title: "Analytics",
          url: ERoutes.Analytics,
        },
      ],
    },
    {
      title: "Invoices",
      url: "/invoices",
      items: [
        {
          title: "Retail",
          url: ERoutes.Retail,
        },
        {
          title: "Wholesale (W)",
          url: ERoutes.Wholesale,
        },
      ],
    },
    {
      title: "Saved",
      url: "/saved",
      items: [
        {
          title: "Products",
          url: ERoutes.Products,
        },
        {
          title: "Distributor / Retailer",
          url: ERoutes.Distributors,
        },
        {
          title: "Purchase",
          url: ERoutes.Purchase,
        },
        {
          title: "Inventory",
          url: ERoutes.Inventory,
        },
      ],
    },
  ],
};

function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  const user = useLocalUser();

  return (
    <Sidebar {...props}>
      <SidebarHeader>
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton size="xl" asChild>
              <a href="/">
                <img src={logoTextIcon} alt="icon" className="h-12 w-auto" />
              </a>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarHeader>
      <SidebarContent>
        {data.navMain.map((section) => (
          <SidebarGroup key={section.title}>
            <SidebarGroupLabel>{section.title}</SidebarGroupLabel>
            <SidebarGroupContent>
              <SidebarMenu>
                {section.items.map((item) => (
                  <SidebarMenuItem key={item.title}>
                    <SidebarMenuButton asChild>
                      <a href={item.url}>{item.title}</a>
                    </SidebarMenuButton>
                  </SidebarMenuItem>
                ))}
              </SidebarMenu>
            </SidebarGroupContent>
          </SidebarGroup>
        ))}
      </SidebarContent>
      <SidebarFooter>
        <NavUser user={user} />
      </SidebarFooter>
      <SidebarRail />
    </Sidebar>
  );
}

export default AppSidebar;
